import { Popover } from "../Popover/index.js";
import { TableDateColumnFilter } from "../TableDateColumnFilter/TableDateColumnFilter.js";
import { isDateTableFilter } from "../TableDateColumnFilter/TableDateColumnFilter.lib.js";
import { TableFioFilter } from "../TableFioFilter/TableFioFilter.js";
import { isListTableFilter } from "../TableListColumnFilter/TableListColumnFilter.lib.js";
import { TableListColumnFilter } from "../TableListColumnFilter/TableListColumnFilter.js";
import { FilterHint } from "./local-components/FilterHint/FilterHint.js";
import React from "react";
import { IconFilterOffAg } from "@synthesis/shared-icons";
import { Fragment, jsx } from "react/jsx-runtime";
//#region src/TableFiltersLine/TableFilterHint.tsx
const isFioTableFilter = (item) => Boolean(item && typeof item === "object" && ("lastName" in item || "firstName" in item || "middleName" in item));
const TableFilterHint = ({ api, filterItem }) => {
	const columnDef = api.getColumnDef(filterItem.column);
	const [isOpen, setIsOpen] = React.useState(false);
	const [filterModel, setFilterModel] = React.useState(filterItem.filterModel);
	React.useEffect(() => {
		const handleFilterChange = () => {
			const currentFilters = api.getFilterModel() ?? {};
			setFilterModel(currentFilters[filterItem.column] ?? null);
		};
		api.addEventListener("filterChanged", handleFilterChange);
		return () => {
			api.removeEventListener("filterChanged", handleFilterChange);
		};
	}, [api, filterItem.column]);
	const handleClose = () => {
		api.destroyFilter(filterItem.column);
		api.onFilterChanged();
		setIsOpen(false);
	};
	const handleModelChange = (nextModel) => {
		const currentFilters = api.getFilterModel() ?? {};
		if (nextModel == null) {
			const { [filterItem.column]: removed, ...rest } = currentFilters;
			api.setFilterModel(rest);
		} else api.setFilterModel({
			...currentFilters,
			[filterItem.column]: nextModel
		});
		api.onFilterChanged();
		setIsOpen(false);
	};
	const renderFilterContent = () => {
		if (!columnDef) return null;
		if (columnDef.filter === TableDateColumnFilter || isDateTableFilter(filterModel)) return /* @__PURE__ */ jsx(TableDateColumnFilter, {
			api,
			colDef: columnDef,
			model: filterModel,
			onModelChange: handleModelChange,
			rowFilter: columnDef.filterParams?.rowFilter
		});
		if (columnDef.filter === TableListColumnFilter || isListTableFilter(filterModel)) {
			const { getItems, getNextPageParam, getItemId, getItemLabel, getItemTooltip, itemsFilter, rowFilter, getQueryKey, withAllSelectCheckbox, withSearch } = columnDef.filterParams ?? {};
			if (!getItems) return null;
			return /* @__PURE__ */ jsx(TableListColumnFilter, {
				api,
				colDef: columnDef,
				model: filterModel,
				onModelChange: handleModelChange,
				getItems,
				getNextPageParam,
				getItemId,
				getItemLabel,
				getItemTooltip,
				itemsFilter,
				rowFilter,
				getQueryKey,
				withAllSelectCheckbox,
				withSearch
			});
		}
		if (columnDef.filter === TableFioFilter || isFioTableFilter(filterModel)) return /* @__PURE__ */ jsx(TableFioFilter, {
			api,
			colDef: columnDef,
			model: filterModel,
			onModelChange: handleModelChange,
			rowFilter: columnDef.filterParams?.rowFilter
		});
		return null;
	};
	return /* @__PURE__ */ jsx(Popover, {
		open: isOpen,
		setIsOpen,
		trigger: /* @__PURE__ */ jsx(FilterHint, {
			icon: columnDef?.filterParams?.filtersLineIcon ?? /* @__PURE__ */ jsx(IconFilterOffAg, { className: "size-5" }),
			label: filterItem.label,
			value: filterItem.value,
			onClose: handleClose,
			onClick: () => setIsOpen(true)
		}),
		align: "start",
		side: "bottom",
		inlineBlock: true,
		children: /* @__PURE__ */ jsx(Fragment, { children: renderFilterContent() })
	});
};
//#endregion
export { TableFilterHint };

//# sourceMappingURL=TableFilterHint.js.map